import { apiClient } from './api';

export type TicketStatus = 'open' | 'in_progress' | 'resolved';

export interface SupportTicket {
  id: string;
  tenantId: string;
  tenantName: string;
  subject: string;
  status: TicketStatus;
  priority: 'low' | 'medium' | 'high';
  updatedAt: string;
}

export interface SupportTicketFilters {
  status?: TicketStatus;
  search?: string;
  page?: number;
  limit?: number;
}

export interface SupportTicketsResponse {
  data: SupportTicket[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

const unwrapEnvelope = <T>(payload: any): T => {
  if (payload?.data !== undefined) {
    return payload.data as T;
  }
  return payload as T;
};

const normalizePaged = (payload: any): SupportTicketsResponse => {
  const root = unwrapEnvelope<any>(payload);

  if (Array.isArray(root?.data) && root?.meta) {
    return {
      data: root.data,
      meta: root.meta,
    };
  }

  const items = root?.items ?? [];
  const meta = root?.meta ?? {
    page: 1,
    limit: Array.isArray(items) ? items.length : 0,
    total: Array.isArray(items) ? items.length : 0,
    totalPages: 1,
  };

  return {
    data: (Array.isArray(items) ? items : []).map((item: any) => ({
      id: item.id,
      tenantId: item.tenant_id ?? item.tenantId,
      tenantName: item.tenant_name ?? item.tenantName,
      subject: item.subject,
      status: item.status,
      priority: item.priority,
      updatedAt: item.updated_at ?? item.updatedAt,
    })),
    meta,
  };
};

export const supportService = {
  getTickets: async (filters: SupportTicketFilters = {}): Promise<SupportTicketsResponse> => {
    const response = await apiClient.get('/support/tickets', { params: filters });
    return normalizePaged(response.data);
  },
};

export default supportService;
